export default function CaseStudiesSection() {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">
            作業時間削減、収量UPを実現！<br />お客様の喜びの声
          </h2>
          <p className="text-xl sm:text-lg text-gray-600">実際に導入されたお客様の成功事例をご紹介</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* 鳥栖市松隈ファーム様の事例 */}
          <div className="bg-gray-50 rounded-2xl p-8 shadow-lg">
            <div className="mb-6">
              <img 
                alt="鳥栖市松隈ファーム様の成功事例" 
                className="w-full h-48 object-cover rounded-lg" 
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/4fc967713a43253c6edd6116ff07ec4d.jpeg"
              />
            </div>
            <div className="flex flex-wrap gap-2 mb-4">
              <span className="px-3 py-1 bg-[#76B947] text-white text-xs rounded-full">#佐賀県</span>
              <span className="px-3 py-1 bg-[#76B947] text-white text-xs rounded-full">#DJI_AGRAS_T50</span>
              <span className="px-3 py-1 bg-[#76B947] text-white text-xs rounded-full">#水稲</span>
              <span className="px-3 py-1 bg-[#76B947] text-white text-xs rounded-full">#馬鈴薯</span>
              <span className="px-3 py-1 bg-[#76B947] text-white text-xs rounded-full">#多量散布</span>
              <span className="px-3 py-1 bg-[#76B947] text-white text-xs rounded-full">#作業効率化</span>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#2A6041] mb-4">
              【鳥栖市 M様 / 馬鈴薯・水稲】<br />
              T50の多量散布で防除効果と農薬の幅が拡大
            </h3>
            <p className="text-gray-600 sm:text-lg leading-relaxed mb-6">
              従来ヘリ散布でしたが、T50導入で防除が一変しました。RTK自動航行と毎分24Lの噴霧で圃場が濡れていても作業可能になり、防除の遅れを解消。多量散布対応で農薬の選択肢と防除効果が向上しました。
            </p>
            <div className="text-gray-400 font-semibold sm:text-lg">
              詳細準備中
            </div>
          </div>

          {/* 佐賀県の事例 */}
          <div className="bg-gray-50 rounded-2xl p-8 shadow-lg">
            <div className="mb-6">
              <img 
                alt="佐賀県小柳様の成功事例" 
                className="w-full h-48 object-cover rounded-lg" 
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/4c2716c0d675b13741a2e6a2e0446f3d.webp"
              />
            </div>
            <div className="flex flex-wrap gap-2 mb-4">
              <span className="px-3 py-1 bg-[#76B947] text-white text-xs rounded-full">#佐賀市</span>
              <span className="px-3 py-1 bg-[#76B947] text-white text-xs rounded-full">#FJDynamics</span>
              <span className="px-3 py-1 bg-[#76B947] text-white text-xs rounded-full">#玉ねぎ</span>
              <span className="px-3 py-1 bg-[#76B947] text-white text-xs rounded-full">#畝たて</span>
              <span className="px-3 py-1 bg-[#76B947] text-white text-xs rounded-full">#収量アップ</span>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#2A6041] mb-4">
              【佐賀市 K様 / 水稲・玉ねぎ】<br />
              畝たてのストレスから完全に解放されました。
            </h3>
            <p className="text-gray-600 sm:text-lg leading-relaxed mb-6">
              FJDの自動操舵は、玉ねぎの畝を真直ぐ立てるのが難しいという悩みを解消し、後のマルチや防除作業が劇的に楽に。さらに、指定幅で正確に走行するため、畝間を数センチ詰めることで1圃場で1列分、畝を増やすことができ、収量アップにつながりました。
            </p>
            <div className="text-gray-400 font-semibold sm:text-lg">
              詳細準備中
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
